<template>
  <ul class="filtersWrapper">
    <filterItem
      v-for="(filter, index) in notEmptyFilters"
      :key="`filter-item-${index}`"
      :class="{'last' : index === notEmptyFilters.length - 1}"
      :filter="filter"
    />
  </ul>
</template>

<script>

// Plugins
import isObject from 'lodash/isObject'

// Components
import filterItem from './FilterItem.vue'

export default {
  name: "QueryListItemFilters",
  props: {
    filters: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    notEmptyFilters() {
      return Object.keys(this.filters)
          .map(key => Object.keys(this.filters[key].values)
            .some(filterKey => (isObject(this.filters[key].values[filterKey]) && Object.keys(this.filters[key].values[filterKey]).length)
              || (Array.isArray(this.filters[key].values[filterKey]) && this.filters[key].values[filterKey].length) ) ? this.filters[key] : null
          ).filter(item => item)

    }
  },

  components: {
    filterItem
  }
}
</script>